export interface FilterAppTextOption {
  id: string;
  label: string;
}

export const FILTER_APP_TEXT_OPTIONS: FilterAppTextOption[] = [
  { id: 'all', label: 'All' },
  { id: 'untranslated', label: 'Untranslated' },
];
